import { useLayoutEffect } from "preact/hooks";

import { usePrevious } from "../../hooks";

const CLEANUP_DELAY = 50;

export function useScrollToLastLine<T extends { _id?: string; }>(
    lastChatLine: T,
    chatOpen: boolean,
    cleanupDelay: number = CLEANUP_DELAY
) {
    const prevChatOpen = usePrevious(chatOpen);
    const prevChatLine = usePrevious(lastChatLine)! ?? {};

    function focusIntoLastLine() {
        const timeoutId = window.setTimeout(() => {
            if (!lastChatLine?._id) {
                return;
            }

            document.getElementById(lastChatLine._id)?.scrollIntoView();
        }, cleanupDelay);

        return () => {
            clearTimeout(timeoutId);
        };
    }

    useLayoutEffect(() => {
        if (prevChatLine?._id !== lastChatLine?._id || (!prevChatOpen && chatOpen)) {
            focusIntoLastLine();
        }
    }, [lastChatLine, cleanupDelay, chatOpen]);
}
